<template>
	<Layout>
		<div class="order-page">
			<div class="page-content">
				<!-- 页面头部 -->
				<div class="page-header">
					<h2>子账号管理</h2>
					<p>管理您的子账号</p>
				</div>
				<div class="m-b-20">
					<el-button icon="el-icon-plus" @click="handleAdd">添加子账号</el-button>
				</div>
				<!-- 数据表格 -->
				<el-card class="card-container" shadow="never">
					
					<el-table  v-loading="loading" :data="tableData" tooltip-effect="light" style="width: 100%" stripe
						:header-cell-style="{ background: '#f8f9fa', color: '#606266', fontWeight: 'bold' }"
						:row-key="getRowKey">
						<el-table-column prop="username" label="账号" min-width="120" show-overflow-tooltip />
						
						<el-table-column prop="createtime" label="创建时间" min-width="170">
							<template slot-scope="scope">{{ scope.row.createtime > 0 ?
									formatTime(scope.row.createtime * 1000, 'Y-M-D h:m') : ' - ' }}</template>
						</el-table-column>
						<el-table-column prop="createtime" label="上次登录时间" min-width="170">
							<template slot-scope="scope">{{ scope.row.logintime > 0 ?
									formatTime(scope.row.logintime * 1000, 'Y-M-D h:m') : ' - ' }}</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" align="center" min-width="120">
							<template slot-scope="scope">
								<el-tooltip :content="scope.row.status ? '已启用' : '已禁用'" placement="top">
								<el-switch
									v-model="scope.row.status"
									:active-value="1"
									:inactive-value="0"
									active-color="#39b54a"
									:loading="scope.row._statusLoading"
									@change="handleStatusChange(scope.row)"
								/>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="remark" label="备注" min-width="140">
							<template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
						</el-table-column>
						<el-table-column label="操作" width="160" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
								<el-button type="text" @click="handleDelete(scope.row)" style="color:#F56C6C">删除</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<div class="pagination-wrapper">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]"
							:page-size="pagination.pageSize" :total="pagination.total" @size-change="handleSizeChange"
							@current-change="handleCurrentChange"></el-pagination>
					</div>
				</el-card>
			</div>
		</div>
		<SubAccountDialog ref="subAccountDialog" @success="getList" />
	</Layout>
</template>

<script>
import Layout from '@/components/Layout/index'
import SubAccountDialog from './components/SubAccountDialog'
import { subAccountList, subAccountDel, subAccountEdit } from '@/api/public'
import { formatTime } from '@/utils/timeTransfer'
export default {
	components: {
		Layout,
		SubAccountDialog
	},
	data() {
		return {
			tableData: [],
			pagination: {
				currentPage: 1,
				pageSize: 10,
				total: 0
			},
			loading: true,
		}
		
	},
	mounted() {
		this.getList()
	},
	methods: {
		formatTime,
		getList(isOnce = false) {
			this.loading = true
			if (isOnce) {
				this.pagination.currentPage = 1
			}
			let params = {
				page: this.pagination.currentPage,
				page_size: this.pagination.pageSize,
			}
			subAccountList(params).then(res => {
				this.loading = false
				const list = res.data.list || []
				this.tableData = list
				this.pagination.total = res.data.total
				console.log(list)
			}).catch(err => {
				this.loading = false
			})
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val
			this.getList(true)
		},
		handleCurrentChange(val) {
			this.pagination.currentPage = val
			this.getList()
		},

		// 获取表格行的唯一key
		getRowKey(row, index) {
			return row.id || index
		},

		// 新增账号
		handleAdd() {
			this.$refs.subAccountDialog.openAdd()
		},

		// 编辑账号
		handleEdit(row) {
			console.log(row)
			this.$refs.subAccountDialog.openEdit(row)
		},

		// 修改状态
		handleStatusChange(row) {
			const newStatus = row.status
			const oldStatus = newStatus === 1 ? 0 : 1
			const label = newStatus === 1 ? '启用' : '禁用'
			// 先恢复开关视觉状态，等确认后再真正修改
			row.status = oldStatus
			this.$confirm(`确认${label}该账号？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				row.status = newStatus
				this.$set(row, '_statusLoading', true)
				subAccountEdit({ id: row.id, status: newStatus }).then(() => {
					this.$message.success(`已${label}`)
				}).catch(() => {
					row.status = oldStatus
				}).finally(() => {
					this.$set(row, '_statusLoading', false)
				})
			}).catch(() => {})
		},

		// 删除账号
		handleDelete(row) {
			this.$confirm('确认删除该账号？删除后不可恢复', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				subAccountDel({ id: row.id }).then(() => {
					this.$message.success('删除成功')
					this.getList()
				})
			}).catch(() => {})
		}
	},
	watch: {
	},

}
</script>

<style scoped lang="scss">
.order-page {
	padding: 20px;
	min-height: calc(100vh - 60px);
	background-color: #f8f9fa;
}

.page-content {
	width: 100%;
	margin: 0 auto;
}

.page-header {
	margin: 24px 0;

	h2 {
		margin: 0 0 8px 0;
		font-size: 24px;
		font-weight: 600;
		color: #303133;
	}

	p {
		margin: 0;
		color: #909399;
		font-size: 14px;
	}
}

.card-container {
	margin-bottom: 20px;
	border-radius: 8px;
	border: 1px solid #ebeef5;

	::v-deep .el-card__body {
		padding: 20px;
	}
}

.pagination-wrapper {
	display: flex;
	justify-content: center;
	margin-top: 20px;
	padding-top: 20px;
}

// 表格优化样式
::v-deep .el-table {
	.el-table__header-wrapper {
		.el-table__header {
			th {
				background-color: #f8f9fa;
				border-bottom: 2px solid #ebeef5;
			}
		}
	}

	.el-table__body-wrapper {
		.el-table__row {
			&:hover {
				background-color: #f8f9fa;
			}
		}
	}
}

// 响应式设计
@media (max-width: 1200px) {
	.page-content {
		max-width: 100%;
		padding: 0 10px;
	}
}

@media (max-width: 768px) {
	.order-page {
		padding: 10px;
	}
}
</style>
